import {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {Navigate, useLocation} from 'react-router';

import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';
import {useAuth} from 'context/AuthContext';

import './ResetPassword.scss';

export default function ResetPassword() {
  const appContext = useAppContext();
  const location = useLocation();
  const {isAuthenticated} = useAuth();
  const [message, setMessage] = useState(null);

  const formMethods = useForm({
    defaultValues: {
      email: '',
    },
  });

  const {handleSubmit, setError} = formMethods;


  if (isAuthenticated) {
    return location?.state?.from?.pathname
      ? <Navigate to={location?.state?.from?.pathname} replace={true} />
      : <Navigate to="/" replace={true} />;
  }

  const onSubmit = async (values) => {
    try {
      const rez = await appContext.api.post('api/v1/users/resetpassword', {
        json: values,
        parseJson: true,
      });
      setMessage(rez.message);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };


  return (
    <div className="resetPasswordPage">
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3 className="text-center mb-3">Reset your password</h3>
          {message && <h4 className="text-success text-center mb-3">{message}</h4>}
          <p className="text-center my-5">Input your registered email to reset your password</p>
          <FormText
            label="Email address"
            name="email"
            required={true}
            className="my-custom-input mb-3"
          />
          <div className="text-center mt-3">
            <FormError />
            <FormSubmit
              key="submit"
              className="btn btn-lg btn-outline-light bg-black text-white"
            >
              Submit
            </FormSubmit>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
